<template>
  <div>
    <!-- list filters -->
    <v-card>
      <v-card-title>
        Communications
      </v-card-title>

      <v-divider class="mt-1"></v-divider>

      <!-- actions -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <!-- search -->
        <v-text-field
          v-model="$store.state.communication.field.keyword"
          placeholder="Rechercher par titre"
          label="Rechercher par titre"
          outlined
          hide-details
          dense
          clearable
          class="user-search me-3 mb-4"
          @click:clear="refreshCommunications"
          @keyup="filterCommunications"
        >
        </v-text-field>

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-tooltip
            left
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="mb-4 me-3"
                small
                v-bind="attrs"
                @click.stop="openForm()"
                v-on="on"
              >
                <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </template>
            <span>Nouvelle communication</span>
          </v-tooltip>

          <v-tooltip
            top
            color="secondary"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                color="secondary"
                class="mb-4 me-3"
                v-bind="attrs"
                small
                v-on="on"
                @click.prevent="refreshCommunications"
              >
                <v-icon>{{ icons.mdiRefresh }}</v-icon>
              </v-btn>
            </template>
            <span>Raffraichir</span>
          </v-tooltip>
        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table
        loading-text="Chargement..."
        no-data-text="Aucun résultat"
        no-results-text="Aucun résultat"
        :headers="headers"
        :items="$store.getters['communication/communications']"
        :items-per-page="$store.getters['communication/per_page']"
        :page.sync="$store.getters['communication/current_page']"
        dense
        fixed-header
        height="500"
        hide-default-footer
        :loading="loading"
        @page-count="currentPage = $event"
      >
        <!-- title -->
        <template #[`item.title`]="{item}">
          <div class="d-flex align-center">
            <v-avatar
              :color="item.highlight_image ? '' : 'primary'"
              :class="item.highlight_image ? '' : 'v-avatar-light-bg primary--text'"
              size="32"
            >
              <v-img
                v-if="item.highlight_image"
                :src="`${item.highlight_image}`"
              ></v-img>
              <span v-else-if="item.title">{{ item.title !== null && item.title !== undefined ? item.title.slice(0,2).toUpperCase() : null }}</span>
              <v-img
                v-else
                :src="require('@/assets/images/avatars/1.png')"
              />
            </v-avatar>
            <div class="d-flex flex-column ms-3">
              <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.title }}</span>
            </div>
          </div>
        </template>
        <template #[`item.created_at`]="{item}">
          {{ formatingDate(`${item.created_at}`) }}
        </template>
        <template #[`item.updated_at`]="{item}">
          {{ formatingDate(`${item.updated_at}`) }}
        </template>
        <template #[`item.deleted_at`]="{item}">
          <v-chip
            v-show="item.deleted_at !== null && item.deleted_at !== undefined"
            small
            color="error"
          >
            {{ item.deleted_at !== null ? formatingDate(`${item.deleted_at}`) : null }}
          </v-chip>
        </template>

        <template #[`item.with_push_notif`]="{item}">
          <v-chip
            small
            :color="item.with_push_notif === true ? 'success' : 'error'"
          >
            {{ item.with_push_notif === true ? "OUI" : "NON" }}
          </v-chip>
        </template>

        <!-- actions -->
        <template #[`item.actions`]="{item}">
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item link>
                <v-list-item-title
                  @click.stop="openForm(item)"
                >
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiPencilOutline }}
                  </v-icon>
                  <span>Modifier</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                @click.prevent="getCommunicationDetails(item.id)"
              >
                <v-list-item-title>
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiFileDocumentOutline }}
                  </v-icon>
                  <span>Détails</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item link>
                <v-list-item-title
                  @click.stop="confirmItem(item)"
                >
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ item.deleted_at !== null && item.deleted_at !== undefined? icons.mdiRestore : icons.mdiDeleteOutline }}
                  </v-icon>
                  <span>{{ item.deleted_at !== null && item.deleted_at !== undefined? "Restaurer" : "Supprimer" }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item link>
                <v-list-item-title
                  @click.stop="confirmDeleteItem(item)"
                >
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiDeleteForever }}
                  </v-icon>
                  <span>Supprimer définitivement</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <v-select
              v-model="$store.state.communication.field.paginate"
              :items="itemsPerPage"
              item-text="text"
              item-value="value"
              label="Lignes par page:"
              type="number"
              min="-1"
              max="15"
              hide-details
              @input="getCommunicationsPerPage"
            ></v-select>
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getCommunications"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <communication-form
      :dialog="dialog"
      :object="item"
      @clickout="dialog = false"
      @submitted="loading"
    />
    <confirm-dialog
      :message="messageDialog"
      :dialog-delete="dialogDelete"
      @clickout="dialogDelete = false"
      @submitted="deleteItem"
    />
  </div>
</template>

<script>
import {
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiPlus,
  mdiFileDocumentOutline,
  mdiDeleteOutline,
  mdiExportVariant,
  mdiAccountOutline,
  mdiRefresh,
  mdiPencilOutline,
  mdiRestore,
  mdiDeleteForever,
} from '@mdi/js'
import { onMounted, ref } from '@vue/composition-api'
import { customFormatDate } from '@core/utils/filter'
import CommunicationForm from '@core/components/communication/CommunicationForm.vue'
import ConfirmDialog from '@core/components/dialogs/ConfirmDialog'
import { notify } from '@core/utils/notification'
import store from '@/store'
import router from '@/router'

export default {
  name: 'Communications',
  components: { ConfirmDialog, CommunicationForm },
  setup() {
    const loading = ref(false)
    const dialogDelete = ref(false)
    const message = ref(null)
    const currentPage = ref(null)
    const lastPage = ref(null)
    const error = ref(null)
    const isAddNewCommunicationSidebarActive = ref(false)
    const usersItems = ref([])
    const messageDialog = ref('')
    const forcedelete = ref(false)
    const itemsPerPage = [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: '15', value: 15 },
      { text: '20', value: 20 },
    ]
    const dialog = ref(false)
    const item = ref({ links: [] })

    const openForm = val => {
      if (val) {
        item.value = {
          id: val.id,
          title: val.title,
          highlight_image: val.highlight_image,
          content: val.content,
          with_push_notif: val.with_push_notif,
          links: [],
        }
      } else {
        item.value = {
          id: null,
          title: null,
          highlight_image: null,
          content: '<p></p>',
          with_push_notif: null,
          links: [{
            url: null, label: null, prefix: null, surfix: null,
          }],
        }
      }
      dialog.value = true
    }

    const getCommunications = (page = 1) => {
      loading.value = true
      store.state.communication.field.user_id = null
      store.dispatch('communication/getCommunications', { page, field: store.state.communication.field }).then(() => {
        currentPage.value = store.getters['communication/current_page']
        lastPage.value = store.getters['communication/last_page']
        loading.value = false
        // eslint-disable-next-line no-shadow
      }).catch(errors => {
        message.value = errors.response.data.message
        error.value = errors.response.data.message
        loading.value = false
      })
    }

    const refreshCommunications = (page = 1) => {
      loading.value = true
      store.state.communication.field.keyword = null
      store.state.communication.field.title = null
      store.state.communication.field.user_id = null
      store.dispatch('communication/refreshCommunications', { page, field: store.state.communication.field }).then(() => {
        currentPage.value = store.getters['communication/current_page']
        lastPage.value = store.getters['communication/last_page']
        loading.value = false
        // eslint-disable-next-line no-shadow
      }).catch(errors => {
        message.value = errors.response.data.message
        error.value = errors.response.data.message
        loading.value = false
      })
    }

    const getCommunicationsPerPage = per_page => {
      loading.value = true
      store.state.communication.field.paginate = per_page
      store.dispatch('communication/getCommunications', { page: store.getters['communication/current_page'], field: store.state.communication.field }).then(() => {
        currentPage.value = store.getters['communication/current_page']
        lastPage.value = store.getters['communication/last_page']
        loading.value = false
        // eslint-disable-next-line no-shadow
      }).catch(errors => {
        message.value = errors.response.data.message
        error.value = errors.response.data.message
        loading.value = false
      })
    }

    const getCommunicationsPerUser = user_id => {
      loading.value = true
      store.dispatch('communication/getCommunications', { page: store.getters['communication/current_page'], field: store.state.communication.field }).then(() => {
        currentPage.value = store.getters['communication/current_page']
        lastPage.value = store.getters['communication/last_page']
        loading.value = false
        // eslint-disable-next-line no-shadow
      }).catch(errors => {
        message.value = errors.response.data.message
        error.value = errors.response.data.message
        loading.value = false
      })
    }

    const getUsers = (page = 1) => {
      store.dispatch('user/getUsers', { page, field: store.state.user.field }).then(() => {
        store.getters['user/users'].forEach(elt => {
          usersItems.value.push({ text: elt.name, value: elt.id })
        })
        // eslint-disable-next-line no-shadow
      }).catch(error => {
        console.log(error)
      })
    }

    const filterCommunications = () => {
      setTimeout(() => {
        getCommunications(store.getters['communication/current_page'])
      }, 1000)
    }

    const formatingDate = date => customFormatDate(date, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    })

    const confirmItem = object => {
      messageDialog.value = object.deleted_at === null || item.value.deleted_at === undefined? `Voulez-vous supprimer la communication ${object.title}?` : `Voulez-vous restaurer la communication ${object.title}?`
      item.value = {
        id: object.id,
        title: object.title,
        highlight_image: object.highlight_image,
        content: object.content,
        with_push_notif: object.with_push_notif,
        deleted_at: object.deleted_at,
        links: [],
      }
      dialogDelete.value = true
      forcedelete.value = false
    }

    const confirmDeleteItem = object => {
      messageDialog.value = `Voulez-vous supprimer définitivement la communication ${object.title}?`
      item.value = {
        id: object.id,
        title: object.title,
        highlight_image: object.highlight_image,
        content: object.content,
        with_push_notif: object.with_push_notif,
        deleted_at: object.deleted_at,
        links: [],
      }
      dialogDelete.value = true
      forcedelete.value = true
    }

    const deleteItem = () => {
      if (forcedelete.value === false) {
        if (item.value.deleted_at === null || item.value.deleted_at === undefined) {
          store.dispatch('communication/deleteCommunication', item.value).then(response => {
            dialogDelete.value = false
            notify(true, true, response.message)
          }).catch(err => {
            message.value = err.response.data.message
            error.value = err.response.data.message
            dialogDelete.value = false
            notify(true, true, err.response.data.message)
          })
        } else {
          store.dispatch('communication/restoreCommunication', item.value).then(response => {
            dialogDelete.value = false
            notify(true, true, response.message)
          }).catch(err => {
            message.value = err.response.data.message
            error.value = err.response.data.message
            dialogDelete.value = false
            notify(true, true, err.response.data.message)
          })
        }
      } else {
        store.dispatch('communication/forceDeleteCommunication', item.value).then(response => {
          dialogDelete.value = false
          notify(true, true, response.message)
        }).catch(err => {
          message.value = err.response.data.message
          error.value = err.response.data.message
          dialogDelete.value = false
          notify(true, true, err.response.data.message)
        })
        dialogDelete.value = false
      }
    }

    onMounted(() => {
      getUsers()
      getCommunications(store.getters['communication/current_page'])
    })

    const getCommunicationDetails = id => {
      router.push({ name: 'communicationDetails', params: { id } })
    }

    return {
      getCommunicationDetails,
      deleteItem,
      confirmItem,
      confirmDeleteItem,
      messageDialog,
      dialogDelete,
      forcedelete,
      dialog,
      openForm,
      item,
      refreshCommunications,
      usersItems,
      getCommunicationsPerUser,
      getCommunications,
      formatingDate,
      getCommunicationsPerPage,
      filterCommunications,
      isAddNewCommunicationSidebarActive,
      loading,
      error,
      currentPage,
      lastPage,
      message,
      itemsPerPage,
      headers: [
        { text: 'TITRE', value: 'title', sortable: false },
        { text: 'AVEC NOTIFICATION PUSH', value: 'with_push_notif', sortable: false },
        { text: 'DATE DE CREATION', value: 'created_at', sortable: false },
        { text: 'DATE DE MISE A JOUR', value: 'updated_at', sortable: false },
        { text: 'DATE DE SUPPRESSION', value: 'deleted_at', sortable: false },
        { text: 'ACTIONS', value: 'actions', sortable: false },
      ],
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiExportVariant,
        mdiAccountOutline,
        mdiRefresh,
        mdiPencilOutline,
        mdiRestore,
        mdiDeleteForever,
      },
    }
  },
}
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>
